// src/pages/subscription/AddOnEditPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Add-ons are edited
// inline on AddOnDetailPage now (AddOnFormDialog reused for edit) — there is
// no edit route/mode, per docs/ux/14-forms.md. This route just sends people
// to the detail page.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const AddOnEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/subscriptions/addons/${id}` : '/subscriptions/addons', { replace: true });
  }, [navigate, id]);
  return null;
};

export default AddOnEditPage;
